import { type Tag, TagInput } from "@repo/ui/components/Base/TagInput";
import { Label } from "@repo/ui/components/Base/Label";
import { cn, uniqueArray } from "@repo/shared/utils";
import { useTenantStore } from "@/stores/tenantStore";

interface TagSelectionProps {
  value: Tag[];
  onChange: (arr: Tag[]) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  enableAutocomplete?: boolean;
  autocompleteOptions?: Tag[];
  useStandardizedTags?: boolean;
}
export const TagSelection = ({
  value,
  onChange,
  label,
  disabled,
  className,
  enableAutocomplete,
  autocompleteOptions,
  useStandardizedTags,
}: TagSelectionProps) => {
  const tenant = useTenantStore((s) => s.tenant);
  const allAutocompleteOptions = uniqueArray<Tag>(
    [...(tenant?.standardTags ?? []), ...(autocompleteOptions ?? [])],
    (a, b) => a.text === b.text
  );

  return (
    <div>
      {label && <Label label={label} />}

      <TagInput
        disabled={disabled}
        interaction={disabled ? "nonClickable" : "clickable"}
        placeholder="Tags &ndash; Comma / Enter submits"
        tags={value}
        addOnBlur={true}
        className={cn(
          "sm:w-[230px] bg-white rounded-lg border-input border p-2",
          className
        )}
        setTags={(newTags) => {
          onChange(newTags as [Tag, ...Tag[]]);
        }}
        enableAutocomplete={enableAutocomplete}
        autocompleteOptions={
          useStandardizedTags ? allAutocompleteOptions : autocompleteOptions
        }
      />
    </div>
  );
};
